import { render } from "./CocktailPage.vue?vue&type=template&id=6033576a&scoped=true"
import script from "./CocktailPage.vue?vue&type=script&lang=js"
export * from "./CocktailPage.vue?vue&type=script&lang=js"

import "./CocktailPage.vue?vue&type=style&index=0&id=6033576a&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6033576a"]])

export default __exports__